module.exports = __webpack_public_path__ + "img/share-popup-copy.0c1f7797.png";